import {
  Avatar,
  Box,
  Button,
  Card,
  CardHeader,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Pagination,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

import React from "react";
import { dressPage1 } from "../../../Data/dress/page1";
import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteProduct,
  findProducts,
} from "../../../Redux/Customers/Product/Action";
import MenuItems from "./MenuItems";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import PaginationItem from "@mui/material/PaginationItem";

const ProductsTable = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { customersProduct } = useSelector((store) => store);
  const [filterValue, setFilterValue] = useState({
    availability: "",
    category: "",
    sort: "",
  });
  const [selectedPageNo, setSelectedPageNo] = useState(1);

  // query
  const searchParams = new URLSearchParams(location.search);
  const availability = searchParams.get("availability");
  const category = searchParams.get("category");
  const sort = searchParams.get("sort");
  const page = searchParams.get("page");

  const handlePaginationChange = (event, value) => {
    setSelectedPageNo(value);
    const data = {
      category: category || "",
      view_all: false,
      colors: [],
      sizes: [],
      minPrice: 0,
      maxPrice: 100000,
      minDiscount: 0,
      sort: sort || "price_low",
      pageNumber: value,
      pageSize: 12,
      stock: availability,
    };
    dispatch(findProducts(data));
  };

  useEffect(() => {
    // setFilterValue({ availability, category, sort });
    const data = {
      category: category || "",
      colors: [],
      sizes: [],
      minPrice: 0,
      maxPrice: 100000,
      minDiscount: 0,
      sort: sort || "price_low",
      pageNumber: page || 1,
      pageSize: 12,
      stock: availability,
    };
    dispatch(findProducts(data));
  }, [availability, category, sort, page, customersProduct.deleteProduct]);

  let selectedCategory = category ? category : "products";

  const handleFilterChange = (e, sectionId) => {
    setFilterValue((values) => ({ ...values, [sectionId]: e.target.value }));
    searchParams.set(sectionId, e.target.value);
    const query = searchParams.toString();
    navigate({ search: `?${query}` });
  };

  const handleDeleteProduct = (productId) => {
    dispatch(deleteProduct(productId));
  };

  const [productList, setProductList] = useState([]);
  useEffect(() => {
    setProductList(customersProduct?.products[`${selectedCategory}`]?.content);
  }, [customersProduct]);


  return (
    <Box width={"100%"}>
      <Box
        sx={{ display: "flex", justifyContent: "flex-end", margin: "20px 0" }}
      >
        <Button
          variant="contained"
          onClick={() => {
            navigate("/admin/product/create");
          }}
        >
          Add Product
        </Button>
      </Box>

      <Card className="mt-2">
        <CardHeader
          title="All Products"
          sx={{
            pt: 2,
            alignItems: "center",
            "& .MuiCardHeader-action": { mt: 0.6 },
          }}
        />
        <TableContainer>
          <Table sx={{ minWidth: 800 }} aria-label="table in dashboard">
            <TableHead>
              <TableRow>
                <TableCell>Image</TableCell>
                <TableCell>Brand</TableCell>
                <TableCell>Title</TableCell>
                <TableCell sx={{ textAlign: "center" }}>Category</TableCell>
                <TableCell sx={{ textAlign: "center" }}>Price</TableCell>
                <TableCell sx={{ textAlign: "center" }}>Quantity</TableCell>
                <TableCell sx={{ textAlign: "center" }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {productList &&
                productList.length &&
                productList?.map((item) => (
                  <TableRow
                    hover
                    key={item._id}
                    sx={{
                      "&:last-of-type td, &:last-of-type th": { border: 0 },
                    }}
                  >
                    <TableCell>
                      <img
                        alt={item.titel}
                        src={`${item?.images[0]}`}
                        width={100}
                        height={100}
                      />
                    </TableCell>

                    <TableCell
                      sx={{ py: (theme) => `${theme.spacing(0.5)} !important` }}
                    >
                      <Box sx={{ display: "flex", flexDirection: "column" }}>
                        <Typography variant="caption">{item.brand}</Typography>
                      </Box>
                    </TableCell>

                    <TableCell
                      sx={{ py: (theme) => `${theme.spacing(0.5)} !important` }}
                    >
                      <Box sx={{ display: "flex", flexDirection: "column" }}>
                        <Typography
                          sx={{
                            fontWeight: 500,
                            fontSize: "0.875rem !important",
                          }}
                        >
                          {item.title}
                        </Typography>
                      </Box>
                    </TableCell>

                    <TableCell sx={{ textAlign: "center" }}>
                      {item.category.title}
                    </TableCell>
                    <TableCell sx={{ textAlign: "center" }}>
                      {item.discountedPrice}
                    </TableCell>
                    <TableCell sx={{ textAlign: "center" }}>
                      {item.quantity}
                      {item.isSizesAvailable &&
                        item.sizes.map((size) => (
                          <p>
                            ({size.name} | {size.quantity ? size.quantity : 0})
                          </p>
                        ))}
                    </TableCell>

                    <TableCell sx={{ textAlign: "center" }}>
                      <MenuItems
                        item={item}
                        handleDeleteProduct={handleDeleteProduct}
                      />
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
      <div className="mx-auto px-4 py-5 flex justify-center shadow-lg rounded-md">
        {customersProduct?.products[`${selectedCategory}`]?.content?.length >
          0 && (
          <section className="w-full">
            <div className="py-5 flex justify-center border">
              <Pagination
                variant="outlined"
                sx={{
                  color: "#b28585",
                }}
                onChange={handlePaginationChange}
                defaultPage={1}
                page={selectedPageNo}
                // count={10}
                count={
                  customersProduct?.products[`${selectedCategory}`]?.totalPages
                }
                renderItem={(item) => (
                  <PaginationItem
                    slots={{
                      previous: ArrowBackIcon,
                      next: ArrowForwardIcon,
                    }}
                    {...item}
                  />
                )}
              />
            </div>
          </section>
        )}
      </div>
    </Box>
  );
};

export default ProductsTable;
